import styled from 'styled-components';
import { getWidth } from '../../../styles';

const PADDING_LAPTOP = '55px';
const INTERCOM_WIDGET = '60px';
const INTERCOM_MARGIN = '24px';

export const SnackbarContainer = styled.div`
  position: fixed;
  bottom: 0;
  margin-bottom: 15px;
  z-index: ${({ theme }) => theme.zIndices.dialogs};
  width: 88%;
  left: 50%;
  transform: translate(-50%);
  margin-left: auto;

  & > div {
    margin-top: 5px;

    &:first-child {
      margin-top: 0;
    }
  }

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    transform: translate(0);
    left: 0;
    margin-bottom: 25px;
    max-width: ${getWidth(20)};
    right: ${PADDING_LAPTOP};
    width: calc(
      100% - (${PADDING_LAPTOP}*2) - ${INTERCOM_WIDGET} - ${INTERCOM_MARGIN}
    );
  }

  ${({ theme }) => `@media screen and ${theme.device.laptop}`} {
    right: auto;
    left: 50%;
    transform: translate(-50%, 0);
  }

  ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
    max-width: ${getWidth(24)};
  }
`;
